/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2021, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

// eslint-disable-next-line max-classes-per-file
import { Component } from '@angular/core';
import { SvgIconRegistry } from '@ngneat/svg-icon';

// SvgIcon is not exported by @ngneat/svg-icon, so we need to define it here.
declare class SvgIcon {
  content: string;

  init: boolean;
  constructor(content: string);
}

/**
 * Component that renders all icons registered with the SvgIconRegistry.
 */
@Component({
  selector: 'bulb-all-icons',
  templateUrl: './all-icons.component.html',
  styleUrls: ['./all-icons.component.scss'],
  standalone: false,
})
export class AllIconsComponent {
  public allIcons:Map<string, SvgIcon>;

  constructor(private registry: SvgIconRegistry) {
    this.allIcons = this.registry.getAll();
  }
}
